// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"62566":"10cec4da7984f239","79637":"589d8a59a4be3154","96549":"fc2acf5697a30d7c"}[chunkId] + ".css";
};